import { Dimensions, PixelRatio } from 'react-native';
import { moderateScale, scale } from 'react-native-size-matters';

const TEXT_SCALE_FACTOR = 0.32;
const WINDOW_WIDTH = Dimensions.get('window').width;
const WINDOW_HEIGHT = Dimensions.get('window').height;
const IMAGE_SCALE_EXPONENT_FACTOR = -1;
const BASELINE_PHONE_DEVICE_ASPECT_RATIO = 0.56; // iPhone13

export function scaleText(value: number): number {
  return moderateScale(value, TEXT_SCALE_FACTOR);
}

export function defaultScale(value: number): number {
  return moderateScale(value, TEXT_SCALE_FACTOR);
}

export function scaleDashboardSliderHeight(value: number): number {
  return moderateScale(value, TEXT_SCALE_FACTOR);
}

export function graphScale(value: number): number {
  return moderateScale(value, 1.5);
}

export function graphScaleLine(value: number): number {
  return moderateScale(value, 0.7);
}

export function fullWidthMinusPadding(padding: number): number {
  return WINDOW_WIDTH - defaultScale(padding);
}

export function graphScaleText(value: number): number {
  return moderateScale(value, 0.6);
}

export function scaledRatio(value: number, ratio: number): number {
  return moderateScale(value, ratio);
}

export function fullScale(value: number): number {
  return PixelRatio.roundToNearestPixel(scale(value));
}

// this will increase the height of images on thin screens (like iPhone13), and decrease height on fat screens (like tablets)
export function scaleImageAspectRatio(originalImageAspectRatio: number): number {
  const baselineDeviceAspectRatio = BASELINE_PHONE_DEVICE_ASPECT_RATIO;
  const currentDeviceAspectRatio = WINDOW_WIDTH / WINDOW_HEIGHT;
  const adjustExponent = IMAGE_SCALE_EXPONENT_FACTOR;
  const currentToBaseline = currentDeviceAspectRatio / baselineDeviceAspectRatio;
  return originalImageAspectRatio / Math.pow(currentToBaseline, adjustExponent);
}
